import {http} from "../utils/http";
import {Response} from '../types/resp';
export const customer = {
	getCashback: async () => {
		return http.get<Response<any>>('/customer/getCashback')
	},

	getCommission: async () => {
		return http.get<Response<any>>('/customer/getCommission')
	},

	getCashbackTurnOverDetail: async (payload: any) => {
		return http.post<Response<any>>('/customer/getCashbackTurnOverDetail', payload)
	},

	getCommissionTurnOverDetail: async (payload: any) => {
		return http.post<Response<any>>('/customer/getCommissionTurnOverDetail', payload)
	},

	updatePeer2PayUID: async (payload: any) => {
		return http.post<Response<any>>('/customer/updatePeer2PayUID', payload)
	},

	getBonus: async (payload: any) => {
		return http.post<Response<any>>('/customer/getBonus', payload)
	},

	getBonusDetail: async (payload: any) => {
		return http.post<Response<any>>('/customer/getBonusDetail', payload)
	},
}
